/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stellar_body/industrial_factor': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M17 9h-1.596a5.452 5.452 0 00-.876-2.113l1.13-1.13c.707-.707-.707-2.121-1.414-1.414l-1.129 1.13A5.444 5.444 0 0011 4.596V3c0-1-2-1-2 0v1.596a5.463 5.463 0 00-2.113.875L5.758 4.343c-.707-.707-2.121.708-1.414 1.415l1.128 1.128A5.447 5.447 0 004.596 9H3c-1 0-1 2 0 2h1.596c.143.773.445 1.49.876 2.114l-1.128 1.128c-.707.707.707 2.121 1.414 1.414l1.128-1.128A5.447 5.447 0 009 15.404V17c0 1 2 1 2 0v-1.596a5.462 5.462 0 002.114-.876l1.129 1.128c.707.707 2.122-.707 1.415-1.414l-1.129-1.129c.43-.624.732-1.341.875-2.113H17c1 0 1-2 0-2zM6.5 10c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"/>'
  }
})
